if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        // When VariantGalleryController is active, delegate all media switching to it
        if (window.VariantGalleryController && window.VariantGalleryController.activeSlides.length > 0) {
          return;
        }

        let activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]:not([style*="display: none"])`) ||
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);

        if (!activeMedia || activeMedia.style.display === 'none') {
          activeMedia = Array.from(this.elements.viewer.querySelectorAll('[data-media-id]')).find(el => el.style.display !== 'none');
        }

        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');


        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft, behavior: 'smooth' });
          }
        });
        this.playActiveMedia(activeMedia);


        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));

        const btn = thumbnail.querySelector('button');
        if (btn) btn.setAttribute('aria-current', true);

        this.elements.thumbnails.querySelectorAll('.thumbnail-list__item, .thumbnail').forEach(el => el.classList.remove('is-active'));
        thumbnail.classList.add('is-active');

        const isDesktop = window.matchMedia('(min-width: 990px)').matches;
        const listContainer = this.elements.thumbnails.querySelector('.thumbnail-list') || this.elements.thumbnails;

        if (isDesktop && listContainer) {
          // Use getBoundingClientRect for accurate position relative to the visible container
          const containerRect = listContainer.getBoundingClientRect();
          const thumbRect = thumbnail.getBoundingClientRect();

          // Check if thumbnail is clipped at the bottom
          if (thumbRect.bottom > containerRect.bottom) {
            const scrollAmount = thumbRect.bottom - containerRect.bottom;
            listContainer.scrollTop += scrollAmount + 8;
          }
          // Check if thumbnail is clipped at the top
          else if (thumbRect.top < containerRect.top) {
            const scrollAmount = containerRect.top - thumbRect.top;
            listContainer.scrollTop -= scrollAmount + 8;
          }
        } else if (listContainer && listContainer.scrollTo) {
          listContainer.scrollTo({ left: thumbnail.offsetLeft - 15, behavior: 'smooth' });
        }
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
